import React from 'react'
import { IoSadOutline } from 'react-icons/io5'
import styled from 'styled-components'

export default function NoSpeaker() {
    return (
        <NoSpeakerStyle>
            <h6>
            <IoSadOutline size={60} />
            </h6>
            <div className="title-bold" >No speaker avaliable</div>
        </NoSpeakerStyle>
    )
}

const NoSpeakerStyle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    align-self: center;
    margin: 0 auto;
    & > div, h6 {
        color: ${prop=>prop.theme.grey}
    }
`;